import React, { useEffect, useState } from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";

import { useDispatch } from "react-redux";
import NewsRequests from "services/news";

import CmtCard from "@coremat/CmtCard";
import CmtCardContent from "@coremat/CmtCard/CmtCardContent";
import PointShopTable from "./PointShopTable";
import CmtSearch from "@coremat/CmtSearch";
import { Box } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  cardRoot: {
    [theme.breakpoints.down("xs")]: {
      "& .Cmt-header-root": {
        flexDirection: "column",
      },
      "& .Cmt-action-default-menu": {
        marginLeft: 0,
        marginTop: 10,
      },
    },
  },
  cardContentRoot: {
    padding: 0,
  },
  actionsContainer: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "20px 20px",
  },
  buttonsContainer: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
  },
}));

const AllPrizes = () => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const [searchVal, setSearchVal] = useState("");

  useEffect(() => {
    if (searchVal.trim().length > 0) {
      dispatch(NewsRequests.getAllPrizes(1, searchVal));
    } else {
      dispatch(NewsRequests.getAllPrizes(1));
    }
  }, [searchVal]);

  return (
    <>
      <CmtCard className={classes.cardRoot}>
        <CmtCardContent className={classes.cardContentRoot}>
          <Box className={classes.actionsContainer}>
            <Box className={classes.buttonsContainer}>
              <CmtSearch
                border={false}
                onlyIcon={false}
                iconPosition="left"
                align="left"
                placeholder="جست و جو"
                value={searchVal}
                onChange={(e) => setSearchVal(e.target.value)}
              />
            </Box>
          </Box>
          <PointShopTable
            searchMode={searchVal.trim().length > 0}
            searchInput={searchVal}
          />
        </CmtCardContent>
      </CmtCard>
    </>
  );
};

export default AllPrizes;
